import { render } from "./RichTextComponent.vue?vue&type=template&id=3bdba7ec&ts=true"
import script from "./RichTextComponent.vue?vue&type=script&lang=ts"
export * from "./RichTextComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
